var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
const textContextSupport = !!document.createTextNode('test').textContent;
export const isNumeric = (n: any) => {
  var t = typeof n === 'undefined' ? 'undefined' : _typeof(n);
  return t == 'number' ? !isNaN(n) && isFinite(n) : t == 'string' ? !n.length ? false : n.length == 1 ? /\d/.test(n) : /^\s*[+-]?\s*(?:(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?)|(?:0x[a-f\d]+))\s*$/i.test(n) : t == 'object' ? !!n && typeof n.valueOf() == 'number' && !(n instanceof Date) : false;
}
export const getInnerText = (element: HTMLElement) =>{
  let textNode = null;
  if (element.childNodes) {
    for (let i = 0; i < element.childNodes.length; i++) {
      if (element.childNodes[i].nodeType === Node.TEXT_NODE) {
        textNode = element.childNodes[i];
        break;
      }
    }
  }
  if (textNode) {
    if (textContextSupport) {
      return textNode.textContent;
    } else {
      return textNode.data;
    }
  } else {
    return null;
  }
}
export const fastInnerText = (element: HTMLElement, content: string) =>{
  let textNode = null;
  if (element.childNodes) {
    for (let i = 0; i < element.childNodes.length; i++) {
      if (element.childNodes[i].nodeType === Node.TEXT_NODE) {
        textNode = element.childNodes[i];
        break;
      }
    }
  }
  if (textNode) {
    if (textContextSupport) {
      textNode.textContent = content;
    } else {
      textNode.data = content;
    }
  } else {
    if (element.firstChild) {
      element.insertBefore(document.createTextNode(content), element.firstChild);
    } else {
      element.appendChild(document.createTextNode(content));
    }
  }
}



// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/spread-sheet/plugins/renderer-helper.ts